import PropTypes from 'prop-types';
import './OrgDisabledCard.css';

const OrgDisabledCard = ({
  organisationName = 'Your Organisation',
  suspendedSince = '',
  onBackToLogin
}) => {
  const initials = organisationName
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(word => word[0].toUpperCase())
    .join('');

  return (
    <div className="org-disabled-card">
      <div className="org-disabled-lock-badge">
        <span className="org-disabled-lock-glow" />
        <svg viewBox="0 0 24 24" fill="none" stroke="#ff5c5c" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round">
          <rect x="4" y="10.5" width="16" height="10" rx="2.5" />
          <path d="M7.5 10.5V7a4.5 4.5 0 0 1 9 0v3.5" />
          <circle cx="12" cy="15" r="1.5" fill="#ff5c5c" stroke="none" />
          <path d="M12 16.5V18" />
        </svg>
      </div>

      <h2 className="org-disabled-card-title">
        This <span className="org-disabled-card-accent">organisation</span> is suspended
      </h2>
      <p className="org-disabled-card-desc">
        You're signed in, but this workspace has been temporarily disabled by an administrator.
        Nothing has been deleted.
      </p>

      <div className="org-disabled-org-strip">
        <div className="org-disabled-avatar">{initials}</div>
        <div className="org-disabled-org-text">
          <div className="org-disabled-org-name">{organisationName}</div>
        </div>
      </div>

      {suspendedSince && (
        <div className="org-disabled-timestamp">
          <span className="org-disabled-timestamp-dot" />
          <div className="org-disabled-timestamp-text">
            <span className="org-disabled-timestamp-label">Suspended since</span>
            <span className="org-disabled-timestamp-value">{suspendedSince}</span>
          </div>
        </div>
      )}

      {onBackToLogin && (
        <div className="org-disabled-card-back-link">
          Wrong account? <button type="button" className="org-disabled-card-back-btn" onClick={onBackToLogin}>Back to login</button>
        </div>
      )}
    </div>
  );
};

OrgDisabledCard.propTypes = {
  organisationName: PropTypes.string,
  suspendedSince: PropTypes.string,
  onBackToLogin: PropTypes.func
};

export default OrgDisabledCard;
